import { ConnectionData } from '../../../global/interfaces';
import * as actions from './my-connections.actions';

export interface State {
    loading: boolean;
    connections: ConnectionData[];
}

export const initialState: State = {
    loading: false,
    connections: []
};

export function reducer(state: State = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.ActionTypes.LOAD_CONNECTIONS:
            return {
                ...state,
                loading: true
            };
        case actions.ActionTypes.LOAD_CONNECTIONS_SUCCESS:
            return {
                ...state,
                connections: action.payload
            };
        case actions.ActionTypes.LOAD_CONNECTIONS_FAILED:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}
